export default "__VITE_ASSET__BRpgID5r__"